/* eslint-disable */
/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-09-20 14:37:24
 * Copyright © Leedarson. All rights reserved.
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import Modal from './Modal';
import { EMPTY_FUNCTION } from './constants';

const ModalInstance = (props) => {
  const finalProps = { ...ModalInstance.defaultProps, ...props };
  const {
    title,
    position,
    content,
    confirm,
    cancel,
    primaryButtons,
    onConfirm,
    onCancel,
    afterClose,
    size,
    sequenceId,
    footerColumn,
    actions,
    onActions,
    wrapClassName,
  } = finalProps;

  //  调用原生弹框
  // if (!window.native.mock && document.querySelector('.native-video-player') && window.native.modal) {
  //   const close = () => {
  //     afterClose(sequenceId);
  //   };

  //   window.native.modal.confirm(
  //     {
  //       title,
  //       content,
  //       confirm,
  //       cancel,
  //       onConfirm,
  //       onCancel,
  //       afterClose: close,
  //     },
  //     globalTheme.primary ? globalTheme.primary.main : '#666',
  //   );
  //   return;
  // }

  const modalRoot = document.createElement('div');
  document.body.appendChild(modalRoot);

  const root = createRoot(modalRoot);

  const close = () => {
    // ReactDOM.unmountComponentAtNode(modalRoot);
    // Warning: Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.
    setTimeout(() => {
      root.unmount();
    });

    if (modalRoot && modalRoot.parentNode) {
      modalRoot.parentNode.removeChild(modalRoot);
    }
    afterClose(sequenceId);
  };

  root.render(
    <Modal
      visible
      position={position}
      title={title}
      cancel={cancel}
      confirm={confirm}
      size={size}
      primaryButtons={primaryButtons}
      onConfirm={onConfirm}
      onCancel={onCancel}
      afterClose={close}
      sequenceId={sequenceId}
      footerColumn={footerColumn}
      wrapClassName={wrapClassName}
      actions={actions}
      onActions={onActions}
    >
      {content}
    </Modal>,
  );

  return {
    close,
  };
};

ModalInstance.defaultProps = {
  title: '',
  position: 'center',
  content: '',
  confirm: 'Ok',
  cancel: 'Cancel',
  primaryButtons: ['confirm'],
  onCancel: EMPTY_FUNCTION,
  onConfirm: EMPTY_FUNCTION,
  afterClose: EMPTY_FUNCTION,
};

export default ModalInstance;
